import { userConstants } from "../_constants/user.constants";
import { deleteCookie } from "../Services/ReportingService";

const HOME_OFFICE = "CWM Home Office";
const FRANCHISE = "City Wide Maintenance (root)";

export const userActions = {
  login,
  logout,
  impersonate,
  changePage,
};

function login(crmUser, currentPageName) {
  return (dispatch) => {
    if (crmUser) {
      dispatch(success(crmUser, currentPageName));
    } else {
      dispatch(failure("Login attempt failed"));
    }
  };

  function success(crmUser, currentPageName) {
    let adminAccessFlag =
      crmUser &&
      crmUser.BusinessUnitReference &&
      (crmUser.BusinessUnitReference.Name === HOME_OFFICE || crmUser.BusinessUnitReference.Name === FRANCHISE);
    return {
      type: userConstants.LOGIN_SUCCESS,
      adminAccess: adminAccessFlag,
      crmUser: crmUser,
      currentPage: currentPageName,
    };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function impersonate(crmUser) {
  return (dispatch) => {
    if (crmUser) {
      sessionStorage.setItem("crmUser", JSON.stringify(crmUser));
      dispatch(impersonation(crmUser));
    }
  };

  function impersonation(crmUser) {
    return { type: userConstants.IMPERSONATE, crmUser };
  }
}

async function logout() {
  sessionStorage.removeItem("crmUser");
  await deleteCookie("chiefThumbsUp");
  await deleteCookie("microsoft-token");
  return (dispatch) => dispatch({ type: userConstants.LOGOUT });
}

function changePage(pageName) {
  let adminAccess = JSON.parse(sessionStorage.getItem("adminAccess"));
  let crmUser = JSON.parse(sessionStorage.getItem("crmUser"));
  sessionStorage.setItem("currentPage", JSON.stringify(pageName));
  return (dispatch) =>
    dispatch({ type: userConstants.CHANGE_PAGE, pageName: pageName, adminAccess: adminAccess, crmUser: crmUser });
}
